import React, { useEffect } from 'react';

function useLocalStorageState(key, defaultValue) {
  const [state, setState] = React.useState(() => {
    let value;

    try {
      value = JSON.parse(window.localStorage.getItem(key) || String(defaultValue));
    } catch (e) {
      value = defaultValue;
    }

    return value;
  });

  useEffect(() => {
    window.localStorage.setItem(key, state);
  }, [key, state]);

  return [state, setState];
}

export default useLocalStorageState;
